import {apiRequest} from "@helpers/query/apiRequest";
import {serialize} from "@helpers/query/serialize";
import {ReverseGeocodingData} from "@containers/reverseGeocoding/types";
import {NOMINATIM_API_URL} from "@constants/config";
import {OnShowError} from "@baseTypes/base";


export const reverseGeocoding = async ({
                                           lat,
                                           lon
                                       }: {
    lat: number,
    lon: number,
}, onError?: OnShowError):Promise<ReverseGeocodingData> => {

    const url = `${NOMINATIM_API_URL}/reverse?` + serialize({
        lat,
        lon,
        format: 'json',
        zoom: 18,
        addressdetails: 1,
        'accept-language': 'uk'
    })
    return await apiRequest<ReverseGeocodingData>({
        url,
        options: {
            method: "GET",
        },
        onError
    })

};
